export default __webpack_public_path__ + "static/media/IconShoppingCart.12f50e84.svg";